import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import Hero from '@/sections/Hero';
import MoreInfoSection from '@/sections/MoreInfo';
import { FaqIntro } from '@/sections/FaqIntro';
import { Button, DownloadButton } from '@/components/buttons';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation, Trans } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import Image from 'next/image';
import { Box } from '@/sections/pricing/Box';
import { BoxRow } from '@/sections/pricing/BoxRow';
import { DelayTable } from '@/sections/pricing/DelayTable';
import { PricingDocuments } from '@/sections/pricing/PricingDocuments';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { SeoHeader } from '@/components/SeoHeader';
import { Text } from '@/components/typography';
import { Link } from '@/components/links';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { mergeClasses } from '@/utils/style';
import { FILES } from '@/constants/files';
import { useRouter } from 'next/router';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import InstallmentsInfo from '@/sections/pricing/InstallmentsInfo';
import { getSectionAnchorId } from '@/utils/anchors';
import MaxiInfo from '@/sections/pricing/MaxiInfo';
import DeferredPaymentInfo from '@/sections/pricing/DeferredPaymentInfo';
import PayInThreeInfo from '@/sections/pricing/PayInThreeInfo';
import { ProductTable } from '@/sections/pricing/ProductTable';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import LoanInfo from '@/sections/pricing/LoanInfo';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(108);
  const {
    pageBanner,
    menuPromoBanners
  } = t0;
  usePageView("pricing");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["pricing", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  const {
    locale
  } = useRouter();
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[8] !== pageBanner?.title || $[9] !== t) {
    t6 = pageBanner?.title ?? t("banner.title");
    $[8] = pageBanner?.title;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== pageBanner?.text || $[12] !== t) {
    t7 = pageBanner?.text ?? t("banner.text");
    $[11] = pageBanner?.text;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = pageBanner && !isHuLanguage ? pageBanner.buttons : null;
  let t9;
  if ($[14] !== isCsLanguage || $[15] !== locale || $[16] !== t) {
    t9 = isCsLanguage && <DownloadButton to={FILES(locale).currentPricingDocumentUntil15102026} testId="pricingValidUntil" analyticsParam="pricingValidUntil" className="self-start"><Trans t={t} i18nKey="pricing.fileCurrentValidUntil">{"15. 10. 2026"}</Trans></DownloadButton>;
    $[14] = isCsLanguage;
    $[15] = locale;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== locale) {
    t10 = FILES(locale);
    $[18] = locale;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isCsLanguage || $[21] !== t) {
    t11 = isCsLanguage ? <Trans t={t} i18nKey="pricing.fileUpcoming">{"16. 10. 2026"}</Trans> : t("pricing.fileCurrent");
    $[20] = isCsLanguage;
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10.currentPricingDocument || $[24] !== t11) {
    t12 = <DownloadButton to={t10.currentPricingDocument} testId="pricing" analyticsParam="pricing" className="mt-2 self-start">{t11}</DownloadButton>;
    $[23] = t10.currentPricingDocument;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <div className="flex flex-col items-center gap-2">{t9}{t12}</div>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = pageBanner?.image?.url ?? "/images/sections/pricing/hero/hero.png";
  let t15;
  if ($[29] !== pageBanner?.image?.alt || $[30] !== t) {
    t15 = pageBanner?.image?.alt ?? t("banner.title");
    $[29] = pageBanner?.image?.alt;
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = {
      url: t14,
      alt: t15
    };
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = pageBanner?.variant || "mascots";
  let t18;
  if ($[35] !== t13 || $[36] !== t16 || $[37] !== t17 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
    t18 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} customButton={t13} image={t16} variant={t17} />;
    $[35] = t13;
    $[36] = t16;
    $[37] = t17;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  let t21;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="bgCircle absolute top-1/4 left-0 hidden -translate-x-1/4 -translate-y-1/2 rotate-90 lg:block" />;
    t21 = <div className="bgCircle absolute right-0 bottom-1/4 hidden translate-x-1/4 -translate-y-1/4 lg:block" />;
    $[44] = t20;
    $[45] = t21;
  } else {
    t20 = $[44];
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = getSectionAnchorId("products");
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t) {
    t23 = t("products.title");
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t23) {
    t24 = <SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.products.title">{t23}</SectionHeadline>;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t) {
    t25 = t("products.text");
    $[51] = t;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t25) {
    t26 = <Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t25}</Text>;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== isCsLanguage) {
    t27 = <div className="flex flex-col gap-4">{isCsLanguage ? <><MaxiInfo /><DeferredPaymentInfo /><PayInThreeInfo /><InstallmentsInfo /><LoanInfo /></> : <ProductTable />}</div>;
    $[55] = isCsLanguage;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = LINKS();
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  const t29 = t28.allProducts;
  let t30;
  if ($[58] !== t) {
    t30 = t("products.cta");
    $[58] = t;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t30) {
    t31 = <Button to={t29} testId="pricingAllProducts" analyticsParam="pricingAllProducts" size="lg" variant="primary" className="mt-12 lg:mt-14" align="center">{t30}</Button>;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t24 || $[63] !== t26 || $[64] !== t27 || $[65] !== t31) {
    t32 = <div className="py-10 lg:py-20" id={t22}>{t24}{t26}{t27}{t31}</div>;
    $[62] = t24;
    $[63] = t26;
    $[64] = t27;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== isCsLanguage || $[68] !== t) {
    t33 = isCsLanguage && <div className="py-10 lg:py-20" id={getSectionAnchorId("maxi")}><SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.maxi.title">{t("maxi.title")}</SectionHeadline><Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t("maxi.text")}</Text><Box><BoxRow left={t("maxi.table.1.title")} right={t("maxi.table.1.text")} /><BoxRow left={t("maxi.table.2.title")} right={t("maxi.table.2.text")} /><BoxRow left={t("maxi.table.3.title")} right={t("maxi.table.3.text")} /><BoxRow left={t("maxi.table.4.title")} right={t("maxi.table.4.text")} /><BoxRow left={t("maxi.table.5.title")} right={t("maxi.table.5.text")} /><BoxRow left={t("maxi.table.6.title")} right={t("maxi.table.6.text")} /><BoxRow left={t("maxi.table.7.title")} right={t("maxi.table.7.text")} /><BoxRow left={t("maxi.table.8.title")} right={t("maxi.table.8.text")} /><BoxRow left={t("maxi.table.9.title")} right={t("maxi.table.9.text")} /><BoxRow left={t("maxi.table.10.title")} right={t("maxi.table.10.text")} /><BoxRow left={t("maxi.table.11.title")} right={t("maxi.table.11.text")} /></Box></div>;
    $[67] = isCsLanguage;
    $[68] = t;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== isCsLanguage || $[71] !== t) {
    t34 = isCsLanguage && <div className="pt-10 pb-14 lg:pt-20 lg:pb-32" id={getSectionAnchorId("delayTable")}><SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.delayTable.title">{t("delayTable.title")}</SectionHeadline><Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t("delayTable.text")}</Text><DelayTable /></div>;
    $[70] = isCsLanguage;
    $[71] = t;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t32 || $[74] !== t33 || $[75] !== t34) {
    t35 = <div className="relative z-30 bg-blue-100 px-4">{t20}{t21}<div className="relative z-10 mx-auto max-w-[60.5rem]">{t32}{t33}{t34}</div></div>;
    $[73] = t32;
    $[74] = t33;
    $[75] = t34;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] !== isCsLanguage || $[79] !== t) {
    t37 = isCsLanguage && <><div className="relative overflow-hidden bg-blue-50"><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-1/2 lg:block" /><div className="relative z-10"><div className="px-4 py-10 lg:py-20" id={getSectionAnchorId("delaySection")}><ContentContainer><div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-10"><div className="w-full shrink"><Image src="/images/sections/pricing/cs/app.png" alt={t("delaySection.title")} width={471} height={471} className="md:max-w-fullg mx-auto max-w-[90%]" /></div><div className="w-[29.25rem] max-w-full shrink-0"><SectionHeadline className="mb-4 lg:text-left" anchorKey="pricing.delaySection.title">{t("delaySection.title")}</SectionHeadline><Text variant="p2" className="mb-4 text-center lg:text-left">{t("delaySection.texts.1")}</Text><Text variant="p2" className="text-center lg:text-left">{t("delaySection.texts.2")}</Text><Button to={LINKS().postponeDueDate} testId="pricingPostponeDueDate" analyticsParam="pricingPostponeDueDate" size="lg" variant="primary" className="mx-auto mt-10 lg:mx-0">{t("delaySection.cta")}</Button></div></div></ContentContainer></div><div id="oldDocuments" className="px-4 pt-10 pb-20 text-center lg:pt-20 lg:pb-40"><SectionHeadline className="mb-12 lg:mb-16" anchorKey="pricing.pricing.title">{t("pricing.title")}</SectionHeadline><PricingDocuments /></div></div></div><SectionDelimiter color="bg-blue-100" background="bg-blue-50" /></>;
    $[78] = isCsLanguage;
    $[79] = t;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  const t38 = isCsLanguage ? "bg-blue-100" : "bg-blue-50";
  let t39;
  if ($[81] !== t38) {
    t39 = mergeClasses("relative overflow-hidden", t38);
    $[81] = t38;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  let t40;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = LINKS();
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  let t41;
  if ($[84] !== isHuLanguage) {
    t41 = isHuLanguage ? LINKS().faqCategory("vasarlas-harom-reszletben") : LINKS().faqCategory("dalsi-caste-otazky");
    $[84] = isHuLanguage;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  let t42;
  if ($[86] !== t41) {
    t42 = <Link to={t41} analyticsParam="faqPricing" testId="faqPricing" />;
    $[86] = t41;
    $[87] = t42;
  } else {
    t42 = $[87];
  }
  let t43;
  if ($[88] !== t || $[89] !== t42) {
    t43 = <div className="py-10 lg:py-20"><FaqIntro link={t40.faq} text={<Trans i18nKey="faq" t={t}>{t42}</Trans>} /></div>;
    $[88] = t;
    $[89] = t42;
    $[90] = t43;
  } else {
    t43 = $[90];
  }
  let t44;
  if ($[91] !== isCsLanguage || $[92] !== t) {
    t44 = <MoreInfoSection buttons={isCsLanguage ? [{
      analyticsParam: "pricingMoreInfoDeferredPayment",
      icon: <IconDeferredPayment className="fillButtonIcon" />,
      testId: "pricingMoreInfoDeferredPayment",
      title: t("core:link.deferredPayment"),
      to: LINKS().deferredPayment
    }, {
      analyticsParam: "pricingMoreInfoRevolvingApplication",
      icon: <IconMaxi className="fillButtonIcon" />,
      testId: "pricingMoreInfoRevolvingApplication",
      title: t("core:products.revolving"),
      to: LINKS().revolving
    }, {
      analyticsParam: "pricingMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "pricingMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "pricingMoreInfoRewards",
      icon: <IconRewards className="fillButtonIcon" />,
      testId: "pricingMoreInfoRewards",
      title: t("core:products.rewards"),
      to: LINKS().rewards
    }] : [{
      analyticsParam: "pricingMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "pricingMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "pricingeMoreWhereToShop",
      icon: <IconShoppingCart className="fillButtonIcon" />,
      testId: "pricingMoreWhereToShop",
      title: t("core:products.whereToShop"),
      to: LINKS().whereToShop
    }, {
      analyticsParam: "pricingMobileApp",
      icon: <IconMobile className="fillButtonIcon" />,
      testId: "pricingMoreInfoMobileApp",
      title: t("core:products.mobileApp"),
      to: LINKS().mobileApp
    }, {
      analyticsParam: "pricingMoreInfoAboutCompany",
      icon: <IconUser className="fillButtonIcon" />,
      testId: "pricingMoreInfoAboutCompany",
      title: t("core:link.aboutUs"),
      to: LINKS().aboutCompany
    }]} />;
    $[91] = isCsLanguage;
    $[92] = t;
    $[93] = t44;
  } else {
    t44 = $[93];
  }
  let t45;
  if ($[94] !== t43 || $[95] !== t44) {
    t45 = <div className="relative z-10">{t43}{t44}</div>;
    $[94] = t43;
    $[95] = t44;
    $[96] = t45;
  } else {
    t45 = $[96];
  }
  let t46;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[97] = t46;
  } else {
    t46 = $[97];
  }
  let t47;
  if ($[98] !== t39 || $[99] !== t45) {
    t47 = <div className={t39}>{t45}{t46}</div>;
    $[98] = t39;
    $[99] = t45;
    $[100] = t47;
  } else {
    t47 = $[100];
  }
  let t48;
  if ($[101] !== menuPromoBanners || $[102] !== t18 || $[103] !== t35 || $[104] !== t37 || $[105] !== t4 || $[106] !== t47) {
    t48 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t18}{t19}{t35}{t36}{t37}{t47}</Layout>;
    $[101] = menuPromoBanners;
    $[102] = t18;
    $[103] = t35;
    $[104] = t37;
    $[105] = t4;
    $[106] = t47;
    $[107] = t48;
  } else {
    t48 = $[107];
  }
  return t48;
}
export const getStaticProps = (async ctx => {
  return {
    props: {
      pageBanner: await getPageBannerBySlug('pricing'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'pricing']))
    }
  };
}) satisfies GetStaticProps<Props>;